import { Box } from '@mui/material'
import Header from './Header'

interface LayoutProps {
  children: React.ReactNode
}

export default function Layout({ children }: LayoutProps) {
  return (
    <Box 
      display="flex" 
      flexDirection="column" 
      minHeight="100vh"
    >
      <Header />

      <Box 
        component="main"
        sx={{ 
          flexGrow: 1,
          maxWidth: 'lg', 
          mx: 'auto', 
          px: { xs: 2, md: 6, lg: 1 }, 
          py: { xs: 4, md: 6 } 
        }}
      >
        {children}
      </Box>

    </Box>
  )
}
